var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-header",
    { tag: "div" },
    [
      _c(
        "sui-container",
        [
          _vm.userProfileType === _vm.profileTypes.ADMINISTRATOR ||
          _vm.userProfileType === _vm.profileTypes.FINANCIAL_ADVISOR ||
          _vm.userProfileType === _vm.profileTypes.STANDARD_USER
            ? [
                _c(
                  "div",
                  {
                    staticClass: "ui three column grid",
                    staticStyle: {
                      "margin-top": "20px",
                      "align-content": "center",
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "column" }, [
                        _vm.userProfileType ===
                          _vm.profileTypes.ADMINISTRATOR ||
                        _vm.userProfileType ===
                          _vm.profileTypes.FINANCIAL_ADVISOR
                          ? _c("div", { staticClass: "ui vertical menu" }, [
                              _c("div", { staticClass: "item" }, [
                                _c(
                                  "div",
                                  { staticClass: "header" },
                                  [
                                    _c("sui-image", {
                                      attrs: {
                                        src: _vm.icons.users,
                                        size: "mini",
                                        spaced: "right",
                                      },
                                    }),
                                    _c("span", [_vm._v("SETUP")]),
                                  ],
                                  1
                                ),
                                _vm.$store.getters.userProfile.profile
                                  .is_super_admin
                                  ? _c("div", { staticClass: "menu" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                name: "firmManager",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("Firm Management")]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "menu" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push({
                                            name: "userManager",
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v("User Management")]
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "header" }, [
                              _c("span", [_vm._v("FORMS")]),
                            ]),
                            _c("div", { staticClass: "menu" }, [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          name: "clientAgreement",
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("Client Agreement Profile")]
                                ),
                              ]),
                              _vm.user.profile.profile_type === 2
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.push({
                                              name: "investorProfileView",
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v("Exhibit B - Investor Profile")]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.calender,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("CALENDAR")]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "menu",
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      name: "calendar",
                                    })
                                  },
                                },
                              },
                              [
                                _c("a", { staticClass: "item" }, [
                                  _vm._v("Calendar"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.compliance,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("COMPLIANCE")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "attestationManager",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Quarterly Attestations")]
                              ),
                            ]),
                            _vm.$store.getters.userProfile.profile.is_super_cco
                              ? _c("div", { staticClass: "menu" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push({
                                            name: "supervisedPersonManager",
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v("Supervised Persons")]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c(
                            "div",
                            { staticClass: "item" },
                            [
                              _c(
                                "div",
                                { staticClass: "header" },
                                [
                                  _c("sui-image", {
                                    attrs: {
                                      src: _vm.icons.investments,
                                      size: "mini",
                                      spaced: "right",
                                    },
                                  }),
                                  _c("span", [_vm._v("INVESTMENTS")]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "menu" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          name: "cashRequestManager",
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("Cash Requests")]
                                ),
                              ]),
                              _c("div", { staticClass: "menu" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          name: "investmentStrategyManager",
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("Investment Strategies")]
                                ),
                              ]),
                              _vm.user.profile.is_investments_user
                                ? [
                                    _c("div", { staticClass: "menu" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                name: "firmFeeScheduleManager",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("Firm Fee Schedules")]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "menu" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                name: "firmModelManager",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("Firm Models")]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "menu" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                name: "feeScheduleManager",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("Fee Schedule List")]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "menu" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push({
                                                name: "modelManager",
                                              })
                                            },
                                          },
                                        },
                                        [_vm._v("Model List")]
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.links,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("LINKS")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://account.box.com/login",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(" Box "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: { click: _vm.initialBlackDiamondSSO },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(" Black Diamond "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://my.dimensional.com/login/",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(" Dimensional Fund Advisors "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://www.finametrica.com/login.aspx",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(" FinaMetrica "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://webaccess.nationaladvisorstrust.com/advisordesk/UserLogin.aspx",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(
                                        " National Advisors Trust Company "
                                      ),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://login.salesforce.com/",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v("Salesforce "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://invest.ameritrade.com/grid/p/login",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(" TD Ameritrade "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _vm.userProfileType ===
                          _vm.profileTypes.ADMINISTRATOR ||
                        _vm.userProfileType ===
                          _vm.profileTypes.FINANCIAL_ADVISOR
                          ? _c("div", { staticClass: "ui vertical menu" }, [
                              _c("div", { staticClass: "item" }, [
                                _c(
                                  "div",
                                  { staticClass: "header" },
                                  [
                                    _c("sui-image", {
                                      attrs: {
                                        src: _vm.icons.lifeImpact,
                                        size: "mini",
                                        spaced: "right",
                                      },
                                    }),
                                    _c("span", [_vm._v("LIFE IMPACT")]),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "menu",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push({
                                          name: "lifeImpact",
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "item",
                                        attrs: { href: "" },
                                      },
                                      [_vm._v("Life Impact Stewardship")]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.training,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("RESOURCES")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "complianceResourceList",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Compliance")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({ name: "faqs" })
                                    },
                                  },
                                },
                                [_vm._v("Frequently Asked Questions")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "investmentsResourceList",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Investments")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "operationsResourceList",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Operations")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "staffDirectory",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Staff Directory")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "videosResourceList",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Videos")]
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.support,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("SUPPORT")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "ticketManager",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Help Requests")]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: _vm.provisionsGroupCommunityPortalUrl,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(" Salesforce Help "),
                                  _c("font-awesome-icon", {
                                    staticStyle: { "margin-left": "8px" },
                                    attrs: { icon: "external-link-alt" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "ticketManager",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Prayer Requests")]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm.userProfileType === _vm.profileTypes.CLIENT
            ? [
                _c(
                  "div",
                  {
                    staticClass: "ui three column grid",
                    staticStyle: {
                      "margin-top": "20px",
                      "align-content": "center",
                    },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "header" }, [
                              _c("span", [_vm._v("FORMS")]),
                            ]),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push({
                                        name: "clientAgreement",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("Client Agreement Profile")]
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.documentVault,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("DOCUMENT VAULT")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://eversourcewa.account.box.com/login",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("Box")]
                              ),
                              _c(
                                "a",
                                { staticClass: "item", attrs: { href: "" } },
                                [_vm._v("Investment Policy Statement")]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.financialPlanning,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("FINANCIAL PLANNING")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    href: "https://wealth.emaplan.com/ema/SignIn",
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("eMoney Advisor")]
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.accountManagement,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("ACCOUNT MANAGEMENT")]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "item",
                                  on: { click: _vm.initialBlackDiamondSSO },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _vm._v("Black Diamond "),
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "external-link-alt" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm.user.profile.is_using_fidelity
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        href: "https://login.fidelity.com/ftgw/Fidelity/RtlCust/Login/Init",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Fidelity "),
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: "external-link-alt",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.user.profile.is_using_national_advisors_trust
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        href: "https://www.nationaladvisors.com/log-in/",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("National Advisors Trust "),
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: "external-link-alt",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.user.profile.is_using_schwab
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        href: "https://client.schwab.com/Login/SignOn/CustomerCenterLogin.aspx",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("Schwab "),
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: "external-link-alt",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.user.profile.is_using_td_ameritrade
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        href: "https://www.advisorclient.com/login",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v("TD Ameritrade "),
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: "external-link-alt",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.lifeImpact,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("LIFE IMPACT STEWARDSHIP")]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "menu",
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      name: "lifeImpact",
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "a",
                                  { staticClass: "item", attrs: { href: "" } },
                                  [_vm._v("Life Impact Stewardship")]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "ui vertical menu" }, [
                          _c("div", { staticClass: "item" }, [
                            _c(
                              "div",
                              { staticClass: "header" },
                              [
                                _c("sui-image", {
                                  attrs: {
                                    src: _vm.icons.calender,
                                    size: "mini",
                                    spaced: "right",
                                  },
                                }),
                                _c("span", [_vm._v("CALENDAR")]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "menu",
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      name: "calendar",
                                    })
                                  },
                                },
                              },
                              [
                                _c("a", { staticClass: "item" }, [
                                  _vm._v("Calendar"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }